import { Suspense } from "react";
import { Outlet, ScrollRestoration } from "react-router";

import { useAuth } from "useAuth";

import SignInPage from "./signin/page";

/**
 * Root admin layout — auth guard.
 * Only allows ak@onlinefitness.app to access the admin panel.
 */
export default function AdminLayout() {
  const { user, loading } = useAuth();

  if (loading) return <div>Loading...</div>;

  if (!user) return <SignInPage />;
  if (user.email !== "ak@onlinefitness.app") return <SignInPage />;

  return (
    <>
      <ScrollRestoration />
      <Suspense fallback={<div>Loading...</div>}>
        <Outlet />
      </Suspense>
    </>
  );
}
